import styled from 'styled-components';

export const ItemContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 335px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* align-items: center; */
  padding: ${({ theme }) => theme.spacing.small};
  box-shadow: 0px 4px 14px ${({ theme }) => theme.palette.darkTransparency};
  margin-bottom: ${({ theme }) => theme.spacing.base};
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const ExamInfoContainer = styled.div`
  color: ${({ theme }) => theme.palette.gray3};
  font-size: 14px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.tinier};
`;
export const Divisor = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray2}33;
  width: 100%;
  align-self: flex-end;
  margin-top: ${({ theme }) => theme.spacing.tiny};
`;
export const ExamTitle = styled.div`
  font-weight: 600;
  margin-right: 42px;
  position: relative;
  width: 90%;
  min-height: 20px;
  display: flex;
  align-items: center;
`;
export const ExamIconWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.gray4};
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

export const DescriptionWrapper = styled.div`
  width: 100%;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.gray3};
  margin-top: ${({ theme }) => theme.spacing.xSmall};
  white-space: pre-line;
  overflow-wrap: break-word;
`;

export const AllowContactButton = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
  margin-top: ${({ theme }) => theme.spacing.small};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
  cursor: pointer;
`;
export const AllowedContactButton = styled.div`
  color: ${({ theme }) => theme.palette.white};
  width: 100%;
  font-size: 14px;
  border-radius: 4px;
  height: 30px;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
  background-color: ${({ theme }) => theme.palette.green1};
  display: flex;
  justify-content: center;
  align-items: center;
`;
